import { createPropType } from '../utils';

// module.exports = createPropType((props, propName, componentName) => {
//   const value = props[propName];
//   const reg = /^(\d+)\x(\d+)$/;
//   if (!reg.test(value)) {
//     return new Error(`Invalid prop ${propName} of ${componentName}, for instance, the value should be 200x150.`);
//   }
//   return null;
// });

export default createPropType((props, propName, componentName) => {
  const value = props[propName];
  const reg = /^(\d+)\x(\d+)$/;
  if (!reg.test(value)) {
    return new Error(`Invalid prop ${propName} of ${componentName}, for instance, the value should be 200x150.`);
  }
  return null;
});
